import { Store, Trash2, Heart } from 'lucide-react';

interface MerchantCardProps {
  name: string;
  slug: string;
  isFavorite?: boolean;
  showFavoriteButton?: boolean;
  onNavigate: (slug: string) => void;
  onToggleFavorite?: (slug: string) => void;
  onRemove?: (slug: string) => void;
}

export function MerchantCard({
  name,
  slug,
  isFavorite,
  showFavoriteButton,
  onNavigate,
  onToggleFavorite,
  onRemove,
}: MerchantCardProps) {
  return (
    <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors">
      <button
        onClick={() => onNavigate(slug)}
        className="flex-1 flex items-center gap-3 text-left"
      >
        <div className="w-10 h-10 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0">
          <Store className="w-5 h-5 text-orange-600" />
        </div>
        <div className="min-w-0">
          <p className="font-medium text-gray-900 truncate">{name || slug}</p>
          <p className="text-sm text-gray-500">/{slug}</p>
        </div>
      </button>
      <div className="flex items-center gap-1">
        {showFavoriteButton && onToggleFavorite && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onToggleFavorite(slug);
            }}
            className={`p-2 rounded-lg transition-colors ${
              isFavorite
                ? 'text-red-500 hover:bg-red-50'
                : 'text-gray-400 hover:bg-gray-200 hover:text-red-500'
            }`}
            title={isFavorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}
          >
            <Heart className={`w-5 h-5 ${isFavorite ? 'fill-current' : ''}`} />
          </button>
        )}
        {onRemove && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              onRemove(slug);
            }}
            className="p-2 text-red-500 hover:bg-red-50 rounded-lg transition-colors"
            title="Retirer des favoris"
          >
            <Trash2 className="w-5 h-5" />
          </button>
        )}
      </div>
    </div>
  );
}
